// extracted by mini-css-extract-plugin
export default {"back-button":"BackButton_back-button__gxObF","loading-value":"BackButton_loading-value__k9ktR"};